const STAGES = [
  { title: "As-is", items: ["Accumulated tools and files", "Spreadsheets, forms, individual knowledge", "Fragmented journeys and hand-offs"] },
  { title: "Simplify & Prove", items: ["Rooms first, bounded pilots", "Distributed ownership and authority", "Measure before and after"] },
  { title: "Connected Mill", items: ["One simple public front door", "Authoritative systems, clear ownership", "Evidence emerges from activity"] },
];

export const ExecAsIsVisual = () => (
  <div className="exec-asis" data-testid="exec-asis-visual">
    {STAGES.map((s, i) => (
      <div className="exec-asis-stage" key={s.title}>
        <div className="exec-asis-stage-title">{s.title}</div>
        <ul>
          {s.items.map((it) => (
            <li key={it}>{it}</li>
          ))}
        </ul>
        {i < STAGES.length - 1 && <span className="exec-asis-arrow" aria-hidden="true">{"\u2192"}</span>}
      </div>
    ))}
  </div>
);
